// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__42XnS","importantInfo":"styles_importantInfo__2CBX2"};